<template>
	<article class="notice-list">
		<page-header>
			<div class="notice-list__header">
				<p class="notice-list__count-info">{{ countInfo }}</p>
				<router-link to="/operation/notice" class="btn blue"
					>등록</router-link
				>
			</div>
		</page-header>
		<managing-section :is-table="true">
			<horizontal-search
				:block-elem="true"
				class="search-by-enter__container"
				@search="search"
				@init="initPage"
			>
				<select-input
					ref="subject"
					label="제목"
					placeholder="입력하세요"
					@change="subjectChange"
				/>
				<select-input
					ref="noticeDate"
					label="등록일"
					:use-period="true"
					@change="noticeDateChange"
				/>
			</horizontal-search>
		</managing-section>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<span class="section__info__left"></span>
				<div class="section__info__right">
					<div class="section__info__items">
						<selector
							v-model="isDisplay"
							title="노출상태"
							:option-list="isDisplayList"
							@input="isDisplayInput"
						/>
					</div>
				</div>
			</template>
			<table class="table-main notice-list__table notice-table">
				<thead>
					<tr>
						<th class="notice-table__no">No</th>
						<th class="notice-table__created">등록일</th>
						<th>제목</th>
						<th class="notice-table__display">노출 상태</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td>{{ item.id }}</td>
						<td>{{ item.parsedCreatedAt }}</td>
						<td class="text-left notice-table__title">
							<router-link
								:to="`/operation/notice?id=${item.id}`"
								class="link"
								>{{ item.subject }}</router-link
							>
						</td>
						<td>{{ item.isDisplayName }}</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="contentTotal"
				:limit="limit"
				:offset="offset"
				@to="paging"
			/>
		</managing-section>
	</article>
</template>
<script>
	import moment from 'moment';
	import PageHeader from '@/components/PageHeader.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import HorizontalSearch from '@/components/HorizontalSearch.vue';
	import SelectInput from '@/components/SelectInput.vue';
	import Selector from '@/components/Selector.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SearchByEnter from '@/components/extends/SearchByEnter.vue';

	export default {
		name: 'NoticeList',
		components: {
			PageHeader,
			ManagingSection,
			HorizontalSearch,
			SelectInput,
			Selector,
			PaginationBox,
		},
		extends: SearchByEnter,
		data() {
			return {
				noticeCount: {
					totalCount: 0,
					displayCount: 0,
					unDisplayCount: 0,
				},
				subject: '',
				noticeDateMin: '',
				noticeDateMax: '',
				contentTotal: 0,
				isDisplayList: [
					{ name: '전체', value: null },
					{ name: '노출', value: 1 },
					{ name: '비노출', value: 0 },
				],
				isDisplay: null,
				limit: 10,
				offset: 0,
				list: null,
			};
		},
		computed: {
			countInfo() {
				return `총 등록 (${this.noticeCount.totalCount}) | 노출 (${this.noticeCount.displayCount}) | 비노출 (${this.noticeCount.unDisplayCount})`;
			},
		},
		watch: {
			'$route.query'() {
				this.getList();
			},
		},
		mounted() {
			this.setFilter();
			this.getList();
		},
		methods: {
			setQuery() {
				const query = {
					offset: String(this.offset),
					limit: String(this.limit),
				};
				if (this.subject) query.subject = this.subject;
				if (this.noticeDateMin)
					query.noticeDateMin = this.noticeDateMin;
				if (this.noticeDateMax)
					query.noticeDateMax = this.noticeDateMax;
				if (typeof this.isDisplay === 'number')
					query.isDisplay = String(this.isDisplay);
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			subjectChange({ input }) {
				this.subject = input;
			},
			noticeDateChange({ from, to }) {
				this.noticeDateMin = from
					? moment(from, 'YYYY-MM-DD').format('x')
					: '';
				this.noticeDateMax = to
					? moment(to, 'YYYY-MM-DD').endOf('date').format('x')
					: '';
			},
			search(offset = 0) {
				this.offset = offset;
				this.setQuery();
			},
			initPage() {
				this.offset = 0;
				this.isDisplay = null;
				this.subject = '';
				this.$refs.subject.init();
				this.noticeDateMin = '';
				this.noticeDateMax = '';
				this.$refs.noticeDate.init();
				this.setQuery();
			},
			isDisplayInput() {
				this.search();
			},
			paging({ offset }) {
				this.search(offset);
			},
			setFilter() {
				const {
					subject,
					noticeDateMin,
					noticeDateMax,
					isDisplay,
					offset,
					limit,
				} = this.$route.query;
				if (subject)
					this.$refs.subject.inputModel = this.subject = subject;
				if (noticeDateMin || noticeDateMax) {
					this.$refs.noticeDate.changePeriod({
						from: noticeDateMin
							? moment(noticeDateMin, 'x').format('YYYY-MM-DD')
							: '',
						to: noticeDateMax
							? moment(noticeDateMax, 'x').format('YYYY-MM-DD')
							: '',
					});
				}
				if (isDisplay) this.isDisplay = Number(isDisplay);
				if (offset) this.offset = Number(offset);
				if (limit) this.limit = Number(limit);
			},
			async getList() {
				const params = {
					offset: this.offset,
					limit: this.limit,
				};
				if (this.subject) params.subject = this.subject;
				if (this.noticeDateMin)
					params.noticeDateMin = this.noticeDateMin;
				if (this.noticeDateMax)
					params.noticeDateMax = this.noticeDateMax;
				if (typeof this.isDisplay === 'number')
					params.isDisplay = this.isDisplay;
				const { data } = await this.$axiosAdmin2.get(
					'/v3/api/notice/list',
					{ params }
				);
				this.noticeCount = data.noticeCount;
				this.contentTotal = data.noticeList.contentTotal;
				this.list = data.noticeList.data.map(item => {
					item.parsedCreatedAt = moment(item.createdAt).format(
						'YYYY.MM.DD HH:mm'
					);
					item.isDisplayName = this.isDisplayList.filter(
						isDisplay => isDisplay.value === item.isDisplay
					)[0].name;
					return item;
				});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.notice-list__header {
		display: flex;
		align-items: center;
	}

	.notice-list__count-info {
		margin-right: 12px;
		font-size: 1rem;
	}

	.notice-table__no {
		width: 60px;
	}

	.notice-table__created {
		width: 160px;
	}

	.notice-table__title {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.notice-table__display {
		width: 90px;
	}
</style>
